import { Image, View } from "@react-pdf/renderer"
import { colors } from "../../../src/config/theme"
import staticPath from "../../config/staticPath"
import Text from "./Text"

const Summary = ({
  score,
  poor,
  good,
  indicator,
}: {
  score: number
  poor: string
  good: string
  indicator: string
}) => (
  <View
    style={{
      backgroundColor: colors.grey,
      height: 200,
      paddingHorizontal: 24,
      paddingVertical: 28,
      marginBottom: 40,
    }}
  >
    <View
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Text
        style={{
          fontSize: 13,
          fontWeight: "bold",
        }}
      >
        {indicator}
      </Text>
      <Text
        style={{
          fontSize: 26,
          fontWeight: "bold",
        }}
      >
        {score}%
      </Text>
    </View>
    <View
      style={{
        flex: 1,
        justifyContent: "flex-end",
      }}
    >
      <View style={{ width: 400, marginHorizontal: 10 }}>
        <Image
          cache={false}
          style={{
            marginLeft: ((400 - 24) / 100) * score,
            height: 12,
            width: 24,
          }}
          src={{
            uri: staticPath("/images/indicator.png"),
            method: "GET",
            headers: {},
            body: "",
          }}
        />
      </View>
      <Image
        cache={false}
        style={{
          height: 51,
          width: 420,
        }}
        src={{
          uri: staticPath("/images/indicator-bar.png"),
          method: "GET",
          headers: {},
          body: "",
        }}
      />
    </View>
    <View
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: 13,
      }}
    >
      <Text>{poor}</Text>
      <Text>{good}</Text>
    </View>
  </View>
)

export default Summary
